<div class="top-level-community-item">
    <a [routerLink]="['/communities/' + community.id]">
        <p>{{ community.name }}</p>
        <div *ngIf="(logo$ | async) as logo" class="top-level-community-item-logo">
            <img [src]="logo._links.content.href" class="img-fluid" [attr.alt]="alternateText ? alternateText : null"/>
        </div>
    </a>
</div>
